import React from 'react';
import './SplashScreen.css';

const SplashScreen = () => {
  return (
    <div className="splash-screen">
      <img src="/logo.png" alt="App Logo" className="splash-logo" />
    </div>
  );
};

export default SplashScreen;
